module.exports = __webpack_public_path__ + "static/media/drafting-compass.5f80111d.svg";